import { useEffect, useRef, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const ClickTooltip = ({ children, tooltipText }) => {
  const [show, setShow] = useState(false);
  const targetRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (targetRef.current && !targetRef.current.contains(event.target)) {
        setShow(false);
      }
    };

    const handleScroll = () => {
      setShow(false);
    };

    document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("scroll", handleScroll, true); // `true` catches inner scrolls

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("scroll", handleScroll, true);
    };
  }, []);

  return (
    <div ref={targetRef} onClick={() => setShow((prev) => !prev)}>
      <OverlayTrigger
        show={show}
        placement="left"
        overlay={<Tooltip>{tooltipText}</Tooltip>}
        target={targetRef.current}
      >
        {children}
      </OverlayTrigger>
    </div>
  );
};

export default ClickTooltip;
